import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64c42518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-num" }

import { t } from '@/plugins/i18n'
import { ref, watch, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import AfterSalesItem from './AfterSalesItem.vue'
import OrderItemTable from '../OrderItemTable.vue'
import Drawer from '@/components/common/Drawer.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props




watch(() => props.visible, (newValue) => {
  if (newValue) {
    toggleAll()
  }
})
const tableConfig = {
  showSelection: true,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  selectable: (row: any) => !row.afterSalesStatus && row.orderItemStatus && row.orderItemStatus.split(',').some((v:any) => v === '9') // 只有发货状态才能勾选
}

const columns:any = [
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    align: 'center',
    width: 230,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center',
    slotName: 'orderQuantity'
  }
]

const STableRef = ref()
const toggleAll = () => {
  nextTick(() => {
    STableRef.value && STableRef.value.toggleAll()
  })
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val
}

const close = () => {
  emit('update:visible', false)
  selectionList.value = []
}

const CVisible = ref(false)
const CItem = ref()
let checkedIdx = 0
const submit = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择需要售后的商品'))
  CItem.value = { ...selectionList.value[0], platformOrderNo: props.rowItem.platformOrderNo }
  CVisible.value = true
  checkedIdx++
}

const cancel = () => {
  CVisible.value = false
  checkedIdx = 0
}
const success = () => {
  if (checkedIdx < selectionList.value.length) {
    CItem.value = { ...selectionList.value[checkedIdx++], platformOrderNo: props.rowItem.platformOrderNo }
  } else {
    CVisible.value = false
    checkedIdx = 0
    close()
    emit('refresh')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Drawer, {
      visible: __props.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      onBeforeClose: close,
      onOk: submit,
      title: _unref(t)('请确认售后信息'),
      showBtn: true,
      size: "1028px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('THE CKB订单编号')) + ": " + _toDisplayString(__props.rowItem.platformOrderNo), 1),
        _createElementVNode("div", null, [
          _createVNode(OrderItemTable, {
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            dataList: __props.dataList,
            columns: columns,
            tableConfig: tableConfig,
            onSelectionChange: handleSelection,
            isAllSelect: false
          }, null, 8, ["dataList"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CommonDialog, {
      visible: CVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((CVisible).value = $event)),
      width: "580px",
      title:  _unref(t)('申请售后'),
      onCancel: cancel
    }, {
      default: _withCtx(() => [
        (CItem.value)
          ? (_openBlock(), _createBlock(AfterSalesItem, {
              key: 0,
              rowItem: CItem.value,
              onCancel: cancel,
              onSuccess: success,
              isChoice: __props.rowItem.tags?.includes(4)
            }, null, 8, ["rowItem", "isChoice"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})